import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import toast from 'react-hot-toast'

const Login: React.FC = () => {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await login(email, password)
      toast.success('خوش آمدید 👋')
      navigate('/')
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err.message || 'خطا در ورود')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container-main flex justify-center py-14">
      <div className="w-full max-w-md">
        <div className="card p-8">
          <h1 className="text-2xl font-black text-gray-900 text-center mb-1">ورود به حساب</h1>
          <p className="text-sm text-gray-500 text-center mb-6">خرید و فروش شمش، آب‌شده، سکه و بار</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">ایمیل</label>
              <input type="email" className="input" dir="ltr" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <label className="label">رمز عبور</label>
              <input type="password" className="input" dir="ltr" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button className="btn btn-primary w-full !py-3 disabled:opacity-50" disabled={loading}>
              {loading ? 'در حال ورود…' : 'ورود'}
            </button>
          </form>

          <p className="text-sm text-gray-500 text-center mt-6">
            حساب کاربری ندارید؟{' '}
            <Link to="/register" className="text-primary-600 font-bold hover:underline">ثبت‌نام کنید</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login